// Print / WhatsApp / Email / No receipt, chosen on the Fashion payment screen
// and remembered per till on this device. Any choice but Print skips only the
// paper print: the bill is saved and synced exactly as before, the sale-done
// screen sends the WhatsApp or email receipt, and it can still print one.
import { isFashionLayout } from "./layout";

export const RECEIPT_CHOICES = Object.freeze({ PRINT: "print", WHATSAPP: "whatsapp", EMAIL: "email", NONE: "none" });
const KNOWN = Object.values(RECEIPT_CHOICES);
const known = (v) => (KNOWN.includes(v) ? v : RECEIPT_CHOICES.PRINT);

// WhatsApp and email go to the bill's customer, so they need a named customer
// with a mobile number or an email address on the record.
export function receiptChannelsFor(customer) {
  const named = Boolean(customer?.name) && customer.name !== "Walk-in";
  return {
    [RECEIPT_CHOICES.WHATSAPP]: named && Boolean(customer.mobileNo || customer.mobile),
    [RECEIPT_CHOICES.EMAIL]: named && Boolean(customer.email),
  };
}

// The choice this bill can use: a digital one its customer can't receive falls back to Print.
export function usableReceiptChoice(choice, customer) {
  const c = known(choice);
  const channels = receiptChannelsFor(customer);
  return c in channels && !channels[c] ? RECEIPT_CHOICES.PRINT : c;
}

export const isDigitalReceipt = (choice) => choice === RECEIPT_CHOICES.WHATSAPP || choice === RECEIPT_CHOICES.EMAIL;

export const receiptChoiceKey = (tillData) => `cw.fashion.receipt.${tillData?.tillAccess?.cwrTill?.cwrTillID || "till"}`;

export function readReceiptChoice(tillData) {
  try {
    return known(localStorage.getItem(receiptChoiceKey(tillData)));
  } catch {
    return RECEIPT_CHOICES.PRINT;
  }
}

export function writeReceiptChoice(tillData, choice) {
  try {
    localStorage.setItem(receiptChoiceKey(tillData), known(choice));
  } catch {
    // per-device convenience only; the default is to print
  }
}

const online = () => (typeof navigator === "undefined" ? true : navigator.onLine !== false);

// Read by order completion with the bill's own customer: true only on a Fashion
// till where this bill needs no paper. No receipt always skips it; WhatsApp or
// Email skips it only for a customer who can get it, and only while the till is
// online to send it. Anything else prints, as before.
export function skipsPaperReceipt(tillData, customer) {
  if (!isFashionLayout(tillData)) return false;
  const choice = usableReceiptChoice(readReceiptChoice(tillData), customer);
  if (choice === RECEIPT_CHOICES.NONE) return true;
  return isDigitalReceipt(choice) && online();
}
